// extracted by mini-css-extract-plugin
export default {"cls1":"VeloFab-Loading_cls1__O9mRy","cls2":"VeloFab-Loading_cls2__ebODr VeloFab-Loading_cls1__O9mRy","extended":"VeloFab-Loading_extended__nG5hg"};